import type {AdvancedFilter} from "../../services/ApiTypes";
import type {Bag} from "../../services/classes/Bag";
import type {CustomerConfigurationMap, DatabagConfiguration} from "../../stores/config/DatabagConfigClasses";
import moment from "moment";
import type ProfileStore from "../../stores/ProfileStore";
import {environment} from "../../env.ts";

/**
 * Loader for the initial state of the advanced dashboard.
 *
 * Note: This must be kept in sync with the BE cache population
 */
export function advancedDashboardLoader(customerConfig: CustomerConfigurationMap, bag: Bag, databagConfig: DatabagConfiguration, profileStore: ProfileStore) {
    // fill the dynamic initial filter with the config
    const baseFilter: AdvancedFilter = {
        // The demo environment does not have the supplier normalization results correctly matched to the spend,
        // So be default we disable this
        group_by_parent_supplier: environment.package === 'sales_demo' ? false
            : Boolean(bag.has_supplier_normalization_results),
    }

    if (profileStore.p.defaultCommonCategoryAdvDashboard) {
        baseFilter.only_common_categories = true;
    }
    if (profileStore.p.defaultCommonSuppliersAdvDashboard) {
        baseFilter.only_common_suppliers = true;
    }

    const dys = customerConfig.get('DATA_YEAR_START');
    if (dys && Number.isInteger(dys.value)) {
        const year = Number(dys.value)
        const start = new Date(year, 0, 1);
        const end = new Date(year + 1, 0, 0); // One day less than next year's start
        // const end = new Date(year, 1, 1); // Debug with just 1 month of data
        baseFilter.date_range = [moment(start).format('YYYY-MM-DD'), moment(end).format('YYYY-MM-DD')];
    }

    return baseFilter;
}